/* eslint-disable */
import React, { Component } from 'react'
import { ScrollView, View, Text, StyleSheet, Dimensions, TouchableOpacity, Image } from 'react-native'
import TextComponent from './TextComponent'
import { Fonts } from '../Themes'
//import Video from 'react-native-video'
//import HTMLView from 'react-native-htmlview'
//import FastImage from 'react-native-fast-image'
import I18n from "i18n-js"

export default class MessageCard extends Component {
  constructor(props) {
    let { width, height } = Dimensions.get('window')
    super(props)
    this.state = { width: width, height: height }
    const { onPress } = this.props
    this.onPress = onPress
  }
  renderHtmlView = (content) => {
    let stylesHtml = StyleSheet.create({
      p: {
        fontFamily: Fonts.style.font.light,

        fontSize: 16,
        color: 'black',
      },
    })
    const htmlContent = `<p>${content}</p>`;
    return <View
      value={htmlContent}
      stylesheet={stylesHtml}
    />
  }
  findBlocks(message, bucketUrl) {
    // TimeStamp, Message Sender (username), Message Sender (user id), Message String
    const { Time, From, FromId, Message, ChatId } = message
    // [bqX9xIxHS7GJp6 MP4 0.7494172494172494]
    let mediaExpr = /\[(\w{14}|\w{32}) (JPEG|MP4|3D) ([+-]?\d+(\.\d+)?)\]/
      // [rS1wkGrQ8tCSp6 MP4 0.75136 cp5758c2680ba4700001ac1f18a333be 1491245193.305288 POST]
      , postExpr = /\[(\w{14}|\w{32}) (JPEG|MP4|3D) ([+-]?\d+(\.\d+)?) (\w{14}|\w{32}) ([+-]?\d+(\.\d+)?) (POST)\]/
    return Message.split(/(\[[^]*?\])|(<br \/>)/).map(function (block) {
      if (typeof block === 'undefined' || !block.length) return false
      if (block === `<br />`) return false

      let media = block.match(mediaExpr)
        , post = block.match(postExpr)

      if (media) { // Media Id [1], Media Type [2], Aspect Ratio [3]


        let uri = bucketUrl + ChatId + '/' + media[1] // Type -> MP4 | 3D | JPEG

        return {
          Type: 'Media', MediaType: media[2], AspectRatio: media[3]
          , thumb: uri + '-thumb.jpg', mp4: uri + '.mp4', full: uri + '.jpg'
        }

      } else if (post) { // PostId [1], Media Type [2], Aspect Ratio [3], UserId [5], TimeStamp [6]

        let uri = bucketUrl + post[1] + '-thumb.jpg'
        return {
          Type: 'Post', thumb: uri, PostId: post[1], UserId: post[5], Username: From
          , MediaType: post[2], AspectRatio: post[3], TimeStamp: post[6]
        }

      } else {

        return { Type: 'Text', Text: block, username: message.OtherUsername }

      }
    }).filter(v => v)
  }


  renderBlock(block, index) {


    let w = this.state.width * (2 / 3), ar = block.AspectRatio || 1, blockWidth = w * (1 / 3)
      , key = index.toString(), h = 50, imgW = h * ar
    switch (block.Type) {
      case 'Text': return (<View style={{ flexDirection: 'row', flexWrap: "wrap" }} key={key}>{this.renderHtmlView(block.Text)}</View>)
      case 'Media':
        if (block.MediaType == "JPEG") {
          return (
            <View onPress={this.onPress} key={key} activeOpacity={0.5} style={{ width: blockWidth }}>
              <Image style={{ width: imgW, height: h, padding: 10, margin: 10 }} resizeMode='contain' source={{ uri: block.thumb }} />
            </View>
          )
        } else {
          return (<Image
            rate={0.0}
            style={{ width: imgW, height: h, marginTop: 10 }}
            resizeMode="cover"
            pause={true}
            source={{ uri: block.thumb }}
            poster={block.thumb}
            repeat={false}
          />)
        }

      case 'Post':
        return (
          <View key={key} activeOpacity={0.5} style={{ width: blockWidth }}>
            <TextComponent text={block.Username} style={{color: Fonts.style.color.baseColor}} />
            <Image style={{ width: imgW, height: h, padding: 10, margin: 10 }} resizeMode='contain' source={{ uri: block.thumb }} />
            <TextComponent text={I18n.t('message.viewPost')} style={{color: Fonts.style.color.baseColor}} />
          </View>
        )
      default: return (null)
    }
  }
  render() {

    const { item, bucketUrl } = this.props.data
    if (!this.props.data) return (<Text></Text>)
    let parts = this.findBlocks(item, bucketUrl)

    return (
      <ScrollView style={{ height: 50, width: this.state.width * (2 / 3) }}
        contentContainerStyle={{ flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start' }}>
        {parts.map(this.renderBlock.bind(this))}
      </ScrollView>
    )
  }
}
